@if (templateMode() === 'relative-presets') {
  <div
    class="ups-date-range-picker ups-date-range-picker--relative-presets"
    data-testid="ups-date-range-picker-relative-presets"
  >
    @if (relativePickerView() === 'presets') {
      <ul class="ups-date-range-picker__relative-presets" role="listbox">
        @for (p of relativeRangePresets; track p) {
          <li role="presentation">
            <button
              type="button"
              class="ups-date-range-picker__relative-preset"
              [class.ups-date-range-picker__relative-preset--active]="
                isRelativePresetActive(p)
              "
              [disabled]="isDisabled()"
              role="option"
              [attr.aria-selected]="isRelativePresetActive(p)"
              (click)="applyRelativePreset(p)"
            >
              {{ relativeRangePresetLabels[p] }}
            </button>
          </li>
        }
        <li role="presentation">
          <button
            type="button"
            class="ups-date-range-picker__relative-preset ups-date-range-picker__relative-preset--custom"
            [disabled]="isDisabled()"
            (click)="openRelativeCustom()"
          >
            Choose custom date range
          </button>
        </li>
      </ul>
    } @else {
      <div
        class="ups-date-range-picker__relative-custom ups-date-range-picker--relative-custom"
      >
        <aside class="ups-date-range-picker__relative-sidebar">
          <ul class="ups-date-range-picker__relative-presets" role="listbox">
            @for (p of relativeRangePresets; track p) {
              <li role="presentation">
                <button
                  type="button"
                  class="ups-date-range-picker__relative-preset"
                  [class.ups-date-range-picker__relative-preset--active]="
                    isRelativePresetActive(p)
                  "
                  [disabled]="isDisabled()"
                  role="option"
                  (click)="applyRelativePreset(p)"
                >
                  {{ relativeRangePresetLabels[p] }}
                </button>
              </li>
            }
          </ul>
        </aside>

        <div class="ups-date-range-picker__relative-calendar">
          <kendo-multiviewcalendar
            kendoDateRangeSelection
            [selectionRange]="draftRange()"
            (selectionRangeChange)="onDraftRangeChange($event)"
            [disabled]="isDisabled()"
            [min]="min()"
            [max]="max()"
          ></kendo-multiviewcalendar>
        </div>

        <div class="ups-date-range-picker__relative-actions">
          <button
            kendoButton
            fillMode="outline"
            type="button"
            [disabled]="isDisabled()"
            (click)="cancelRelativeCustom()"
          >
            Cancel
          </button>
          <button
            kendoButton
            themeColor="primary"
            type="button"
            [disabled]="
              isDisabled() || !draftRange().start || !draftRange().end
            "
            (click)="applyRelativeCustom()"
          >
            Apply
          </button>
        </div>
      </div>
    }
  </div>
} @else {
  <div
    class="ups-date-range-picker d-flex align-items-center gap-2 flex-wrap"
    data-testid="ups-date-range-picker-default"
  >
    <!-- Manual From/To Date Range -->
    <kendo-daterange>
      <kendo-dateinput
        kendoDateRangeStartInput
        [value]="range().start"
        (valueChange)="onManualRangeChange({ start: $event, end: range().end })"
        [disabled]="isDisabled()"
        [min]="min()"
        [max]="max()"
        format="MM/dd/yyyy"
        placeholder="From"
      ></kendo-dateinput>
      <kendo-dateinput
        kendoDateRangeEndInput
        [value]="range().end"
        (valueChange)="
          onManualRangeChange({ start: range().start, end: $event })
        "
        [disabled]="isDisabled()"
        [min]="min()"
        [max]="max()"
        format="MM/dd/yyyy"
        placeholder="To"
      ></kendo-dateinput>
    </kendo-daterange>

    <!-- Year Dropdown -->
    <kendo-dropdownlist
      [disabled]="isDisabled()"
      [data]="yearsInternal()"
      [value]="selectedYear()"
      (valueChange)="onYearChange($event)"
      [style.width.px]="110"
    ></kendo-dropdownlist>

    <!-- Preset Buttons -->
    <kendo-buttongroup>
      @for (p of presetOptions; track p) {
        <button
          kendoButton
          [themeColor]="preset() === p ? 'primary' : 'base'"
          [fillMode]="preset() === p ? 'solid' : 'outline'"
          [disabled]="isDisabled()"
          [class.text-white]="preset() === p"
          (click)="applyPreset(p)"
        >
          {{ p }}
        </button>
      }
    </kendo-buttongroup>

    <!-- Clear Button -->
    @if (showClear()) {
      <button
        kendoButton
        fillMode="outline"
        [disabled]="isDisabled()"
        (click)="clearPreset()"
      >
        Clear
      </button>
    }
  </div>
}
